<template>
  <div class="d-flex flex-column align-items-center">
    <img
      :src="require('@slg/web-customer-shared/src/assets/img/no-trips.svg')"
      class="mt-10"
      :alt="$t('imageAlt.noTrips')"
    >
    <h5 class="heading-5 textPrimary--text">
      {{ title }}
    </h5>
    <span class="body-1 my-4">
      {{ $t('trips.noTripsText') }}
    </span>
    <VBtn
      color="brandingPrimary"
      outlined
      :to="{ name: 'Booking', params: { lang: $route.params.lang }}"
    >
      <span class="button">
        {{ $t('trips.bookTrip') }}
      </span>
    </VBtn>
  </div>
</template>

<script lang="ts">
export default {
  name: 'NoTrips',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n, useRouteRef } from '../../composables';

const { t } = useI18n();
const route = useRouteRef();

const title = computed(() => {
  const routeName = route.value.name;
  switch (routeName) {
    case 'Past':
      return t('trips.noPastTripsText');
    case 'Canceled':
      return t('trips.noCancelledTripsText');
    case 'Planned':
    default:
      return t('trips.noPlannedTripsText');
  }
});
</script>
